import { ReactNode } from 'react';
import { Box, Text, Button } from '@mantine/core';
import { SETTINGS_ACCESS_ROLES } from '../hooks/useUserPermissions';
import { useCurrentUser } from '../hooks/useCurrentUser';
interface AdminProtectedRouteProps {
  children: ReactNode;
}

export const AdminProtectedRoute = ({ children }: AdminProtectedRouteProps) => {
  const user = useCurrentUser();
  const role = user?.role ?? '';
  const hasAccess = SETTINGS_ACCESS_ROLES.includes(role);
  // Check if user is admin
  if (!hasAccess) {
    return (
      <Box p="xl" ta="center">
        <Text size="xl" fw={600} mb="md">Access Denied</Text>
        <Text color="dimmed" mb="lg">
          You don't have permission to access this page. Only administrators can view settings.
        </Text>
        <Button onClick={() => window.history.back()}>
          Go Back
        </Button>
      </Box>
    );
  }
  
  return <>{children}</>;
}; 